import { env } from '@/lib/env';

export const interceptConfig = {
  baseUrl: env.NEXT_PUBLIC_GATEWAY_URL,
  intercepts: [
    {
      basepoint: '/user',
      destinationHost: process.env.NEXT_PUBLIC_USER_SERVICE_DEV,
      destinationScheme: 'https',
      enable: false,
    },
    {
      basepoint: '/customer',
      destinationHost: process.env.NEXT_PUBLIC_CUSTOMER_SERVICE_DEV,
      destinationScheme: 'https',
      enable: false,
    },
    {
      basepoint: '/product',
      destinationHost: process.env.NEXT_PUBLIC_PRODUCT_SERVICE_DEV,
      destinationScheme: 'https',
      enable: false,
    },
    {
      basepoint: '/sites',
      destinationHost: process.env.NEXT_PUBLIC_SITES_SERVICE_DEV,
      destinationScheme: 'https',
      enable: true,
    },
    {
      basepoint: '/orders',
      destinationHost: process.env.NEXT_PUBLIC_ORDER_SERVICE_DEV,
      destinationScheme: 'https',
      enable: false,
    },
  ],
};
